import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "home": "Home",
      "university_line1": "OSH TECHNOLOGICAL",
      "university_line2": "UNIVERSITY named after M.M.Adyshev",
      "support_association": "SUPPORT THE ASSOCIATION",
      "login": "Login",
      "register": "Register",
      "nav_home": "Home",
      "nav_about": "About Us",
      "nav_news": "News",
      "nav_students": "For Students",
      "nav_alumni": "For Alumni",
      "nav_career": "Career Center",
      "nav_success_stories": "Success Stories",
      "nav_partners": "Partners",
      "nav_find_alumni": "Find Alumni",
      "nav_contact": "Contacts",
      "nav_employment_stats": "Employment",
      "hero_title": "OshTU Alumni Community",
      "hero_description": "Join us to reconnect with friends, share experiences, and stay informed!",
      "join_community": "Join the Community",
      "graduates": "Graduates",
      "find_alumni": "Find an Alumni",
      "find_alumni_desc": "Find your friends, colleagues, and classmates in one click.",
      "go_to_search": "Go to Search",
      "new_graduate": "Are you a new OshTU graduate?",
      "add_your_info": "Add your details so your classmates can find you!",
      "add_myself": "Add Myself",
      "quick_access": "Quick Access",
      "section_main": "Main",
      "section_students_alumni": "For Students and Alumni",
      "section_partners": "Partnership & Participation",
      "survey": "Survey",
      "stay_informed": "Stay Updated",
      "stay_informed_desc": "Subscribe to our news, join events, and follow updates.",
      "read_forum": "Read Forum",
      "about_hero_title": "We didn't just create a website - we built a bridge between generations",
      "about_hero_subtitle": "This platform isn't about the past. It's about the future. About people who were, are, and will be part of something bigger.",
      "about_vision_title": "<FaRocket /> Our Vision",
      "about_vision_text": "We believe every graduate is a story that can inspire. Our site is a connection point for memories, experiences and future ideas. Where new projects are born, where help comes from unexpected places. We're building a digital alumni ecosystem.",
      "about_mission_title": "<FaLightbulb /> Mission",
      "about_mission_text": "Not just keeping in touch. We want to <strong>inspire</strong>. Provide a platform for those moving forward, who want to share, who want to change the world starting with their alma mater.",
      "about_features_title": "<FaCompass /> Platform Features",
      "about_features_list1": "Unique alumni catalog by years, groups, faculties",
      "about_features_list2": "Inspirational success stories",
      "about_features_list3": "Forum - ideas, discussions, debates, growth",
      "about_features_list4": "Alumni fund - collective power for real impact",
      "about_features_list5": "Events that bring everyone together again",
      "about_community_title": "<FaGlobe /> Who's Here?",
      "about_community_list1": "Graduates who've achieved great things",
      "about_community_list2": "Students with everything ahead of them",
      "about_community_list3": "Teachers who gave their soul",
      "about_community_list4": "Partners who believe in intellect",
      "about_future_title": "<FaUsers /> What's Next?",
      "about_future_text": "We won't stop. We'll develop a mobile app. Add an AI mentor matching system. Create a global alumni map. And build a <strong>truly digital campus</strong> where geography doesn't matter.",
      "about_quote": "\"Leave your mark. Share your experience. Be an example.\"",
      "about_quote_sub": "This isn't just a website. It's a movement. And you're part of it.",
      "about_join_button": "Join the community <FaArrowRight />",
      "news_title": "OshTU News",
      "news_subtitle": "Latest achievements and innovations of our university",
      "news_0_title": "OshTU Launches Innovation Hub ",
      "news_0_date": "April 12, 2025",
      "news_0_desc": "New center at IT faculty prepares leaders in AI field",
      "news_1_title": "Students Create Eco-Drone",
      "news_1_date": "March 5, 2025",
      "news_1_desc": "Engineers developed a drone for river cleaning",
      "news_read_more": "Read more",
      "students_title": "Support for OshTU Students",
      "students_subtitle": "Programs and opportunities for your professional growth and development",
      "students_scholarship_title": "<FaGraduationCap /> OshTU Alumni Association Scholarship Program",
      "students_scholarship_desc1": "This strategic project helps young specialists unlock their potential, gain recognition in the scientific community and receive financial support. Second-year full-time master's students can participate.",
      "students_scholarship_desc2": "To participate, register on the website and submit an application through your Personal Account.",
      "students_mentorship_title": "<FaHandshake /> Mentorship Program for OshTU Students",
      "students_mentorship_desc1": "A unique opportunity for students to receive support from an experienced mentor in their field of specialization. The program helps with development and building useful connections.",
      "students_mentorship_desc2": "Register on the website and submit an application through your Personal Account to join the program.",
      "students_platform_title": "<FaLaptopCode /> Digital Development Platform",
      "students_platform_desc": "On the website, students can create personal accounts, track participation in programs, receive notifications about scholarships, events and internship opportunities from OshTU partners.",
      "students_events_title": "<FaBullhorn /> Latest News and Events",
      "students_events_desc": "Stay updated on the latest events: scientific conferences, career trainings, master classes and much more. Everything important for the student community is here.",
      "students_apply_button": "Apply now",
      "students_explore_button": "Explore platform",
      "students_view_events_button": "View events",
      "employment_stats_title": "Graduate Employment",
      "employment_stats_description": "Up-to-date statistics and opportunities for our university graduates",
      "view_stats_button": "View Statistics",
      "career_opportunities": "Job Opportunities",
      "success_stories": "Success Stories",
      "employment_rate": "Employment Rate",
      "companies_partners": "Partner Companies",
      "graduates_last_year": "Graduates Last Year"
    }
  },
  ru: {
    translation: {
      "home": "Главная",
      "university_line1": "ОШСКИЙ ТЕХНОЛОГИЧЕСКИЙ",
      "university_line2": "УНИВЕРСИТЕТ им М.М.Адышева",
      "support_association": "ПОДДЕРЖАТЬ АССОЦИАЦИЮ",
      "login": "Вход",
      "register": "Регистрация",
      "nav_home": "Главная",
      "nav_about": "О нас",
      "nav_news": "Новости",
      "nav_students": "Студентам",
      "nav_alumni": "Выпускникам",
      "nav_success_stories": "История успеха",
      "nav_career": "Карьерный центр",
      "nav_partners": "Партнеры",
      "nav_find_alumni": "Найти выпускника",
      "nav_contact": "Контакты",
      "nav_employment_stats": "Трудоустройство",
      "hero_title": "Сообщество выпускников ОШТУ",
      "hero_description": "Присоединяйся к нам, находи друзей, делись опытом и будь в курсе всех событий!",
      "join_community": "Стать частью сообщества",
      "graduates": "Выпускники",
      "find_alumni": "Найти выпускника",
      "find_alumni_desc": "Найдите своих друзей, коллег и однокурсников в один клик.",
      "go_to_search": "Перейти к поиску",
      "new_graduate": "Вы новый выпускник ОшТУ?",
      "add_your_info": "Добавьте свои данные, чтобы вас могли найти однокурсники!",
      "add_myself": "Добавить себя",
      "quick_access": "Быстрый доступ",
      "section_main": "Основное",
      "section_students_alumni": "Для студентов и выпускников",
      "section_partners": "Партнерство и участие",
      "survey": "Опрос",
      "stay_informed": "Будь в курсе событий",
      "stay_informed_desc": "Подписывайся на наши новости, участвуй в мероприятиях и следи за обновлениями.",
      "read_forum": "Читать форум",
      "about_hero_title": "Мы не просто создали сайт — мы построили мост между поколениями",
      "about_hero_subtitle": "Эта платформа — не о прошлом. Она о будущем. О людях, которые были, есть и будут частью чего-то большего.",
      "about_vision_title": "<FaRocket /> Наше видение",
      "about_vision_text": "Мы верим, что каждый выпускник — это история, которая может вдохновить. Наш сайт — это точка соединения воспоминаний, опыта и будущих идей. Это место, где рождаются новые проекты, где помощь приходит оттуда, откуда ты не ждал. Мы строим цифровую экосистему выпускников.",
      "about_mission_title": "<FaLightbulb /> Миссия",
      "about_mission_text": "Не просто поддерживать связь. Мы хотим <strong>вдохновлять</strong>. Давать платформу тем, кто делает шаги вперёд, кто хочет делиться, кто хочет изменить этот мир, начав с родного университета.",
      "about_features_title": "<FaCompass /> Возможности платформы",
      "about_features_list1": "Уникальный каталог выпускников по годам, группам, факультетам",
      "about_features_list2": "Истории, которые вдохновляют двигаться дальше",
      "about_features_list3": "Форум — идеи, предложения, разговоры, споры, рост",
      "about_features_list4": "Фонд выпускников — где сила объединения превращается в реальные действия",
      "about_features_list5": "События, которые снова собирают всех вместе",
      "about_community_title": "<FaGlobe /> Кто здесь?",
      "about_community_list1": "Выпускники, которые добились многого",
      "about_community_list2": "Студенты, у которых всё впереди",
      "about_community_list3": "Преподаватели, вложившие душу",
      "about_community_list4": "Партнёры, которые верят в интеллект",
      "about_future_title": "<FaUsers /> Что дальше?",
      "about_future_text": "Мы не остановимся. Мы будем развивать мобильное приложение. Добавим AI-систему для подбора наставников. Сделаем глобальную карту выпускников. И создадим <strong>истинно цифровой кампус</strong>, где география не имеет значения.",
      "about_quote": "«Оставь след. Делись опытом. Будь примером.»",
      "about_quote_sub": "Это не просто сайт. Это движение. И ты — его часть.",
      "about_join_button": "Стать частью сообщества <FaArrowRight />",
      "news_title": "Новости ОшТУ",
      "news_subtitle": "Последние достижения и инновации нашего университета",
      "news_0_title": "ОшТУ запускает Инновационный Хаб ",
      "news_0_date": "12 апреля 2025",
      "news_0_desc": "Новый центр на базе ИТ-факультета готовит лидеров в сфере ИИ",
      "news_1_title": "Студенты создают дрона-эколога",
      "news_1_date": "5 марта 2025",
      "news_1_desc": "Инженеры разработали дрон для очистки рек",
      "news_read_more": "Подробнее",
      "students_title": "Поддержка студентов ОшТУ",
      "students_subtitle": "Программы и возможности для вашего профессионального роста и развития",
      "students_scholarship_title": "<FaGraduationCap /> Стипендиальная программа Ассоциации выпускников ОшТУ",
      "students_scholarship_desc1": "Это стратегический проект, который помогает молодым специалистам раскрыть свой потенциал, получить признание в научной среде и финансовую поддержку. Участвовать могут магистранты второго курса очной формы обучения.",
      "students_scholarship_desc2": "Чтобы принять участие, зарегистрируйтесь на сайте и подайте заявку через Личный кабинет.",
      "students_mentorship_title": "<FaHandshake /> Менторская программа для студентов ОшТУ",
      "students_mentorship_desc1": "Это уникальная возможность для студентов — получить поддержку опытного наставника в сфере своей специализации. Программа помогает развиваться и строить полезные связи.",
      "students_mentorship_desc2": "Зарегистрируйтесь на сайте и подайте заявку через Личный кабинет, чтобы присоединиться к программе.",
      "students_platform_title": "<FaLaptopCode /> Цифровая платформа для развития",
      "students_platform_desc": "На сайте студенты могут создавать личные кабинеты, отслеживать участие в программах, получать уведомления о стипендиях, мероприятиях и возможностях стажировок от партнёров ОшТУ.",
      "students_events_title": "<FaBullhorn /> Свежие новости и мероприятия",
      "students_events_desc": "Будьте в курсе последних событий: научные конференции, карьерные тренинги, мастер-классы и многое другое. Всё важное для студенческого сообщества — здесь.",
      "students_apply_button": "Подать заявку",
      "students_explore_button": "Изучить платформу",
      "students_view_events_button": "Смотреть мероприятия",
      "employment_stats_title": "Трудоустройство выпускников",
      "employment_stats_description": "Актуальная статистика и возможности для выпускников нашего университета",
      "view_stats_button": "Посмотреть статистику",
      "career_opportunities": "Вакансии",
      "success_stories": "Истории успеха",
      "employment_rate": "Уровень трудоустройства",
      "companies_partners": "Компаний-партнеров",
      "graduates_last_year": "Выпускников в прошлом году"
    }
  },
  kg: {
    translation: {
      "home": "Главная",
      "university_line1": "ОШСКИЙ ТЕХНОЛОГИЧЕСКИЙ",
      "university_line2": "УНИВЕРСИТЕТ им М.М.Адышева",
      "support_association": "ПОДДЕРЖАТЬ АССОЦИАЦИЮ",
      "login": "Вход",
      "register": "Регистрация",
      "nav_home": "Главная",
      "nav_about": "О нас",
      "nav_news": "Новости",
      "nav_students": "Студентам",
      "nav_alumni": "Выпускникам",
      "nav_success_stories": "История успеха",
      "nav_career": "Карьерный центр",
      "nav_partners": "Партнеры",
      "nav_find_alumni": "Найти выпускника",
      "nav_contact": "Контакты",
      "nav_employment_stats": "Трудоустройство",
      "hero_title": "Сообщество выпускников ОШТУ",
      "hero_description": "Присоединяйся к нам, находи друзей, делись опытом и будь в курсе всех событий!",
      "join_community": "Стать частью сообщества",
      "graduates": "Выпускники",
      "find_alumni": "Найти выпускника",
      "find_alumni_desc": "Найдите своих друзей, коллег и однокурсников в один клик.",
      "go_to_search": "Перейти к поиску",
      "new_graduate": "Вы новый выпускник ОшТУ?",
      "add_your_info": "Добавьте свои данные, чтобы вас могли найти однокурсники!",
      "add_myself": "Добавить себя",
      "quick_access": "Быстрый доступ",
      "section_main": "Основное",
      "section_students_alumni": "Для студентов и выпускников",
      "section_partners": "Партнерство и участие",
      "survey": "Опрос",
      "stay_informed": "Будь в курсе событий",
      "stay_informed_desc": "Подписывайся на наши новости, участвуй в мероприятиях и следи за обновлениями.",
      "read_forum": "Читать форум",
      "about_hero_title": "Мы не просто создали сайт — мы построили мост между поколениями",
      "about_hero_subtitle": "Эта платформа — не о прошлом. Она о будущем. О людях, которые были, есть и будут частью чего-то большего.",
      "about_vision_title": "<FaRocket /> Наше видение",
      "about_vision_text": "Мы верим, что каждый выпускник — это история, которая может вдохновить. Наш сайт — это точка соединения воспоминаний, опыта и будущих идей. Это место, где рождаются новые проекты, где помощь приходит оттуда, откуда ты не ждал. Мы строим цифровую экосистему выпускников.",
      "about_mission_title": "<FaLightbulb /> Миссия",
      "about_mission_text": "Не просто поддерживать связь. Мы хотим <strong>вдохновлять</strong>. Давать платформу тем, кто делает шаги вперёд, кто хочет делиться, кто хочет изменить этот мир, начав с родного университета.",
      "about_features_title": "<FaCompass /> Возможности платформы",
      "about_features_list1": "Уникальный каталог выпускников по годам, группам, факультетам",
      "about_features_list2": "Истории, которые вдохновляют двигаться дальше",
      "about_features_list3": "Форум — идеи, предложения, разговоры, споры, рост",
      "about_features_list4": "Фонд выпускников — где сила объединения превращается в реальные действия",
      "about_features_list5": "События, которые снова собирают всех вместе",
      "about_community_title": "<FaGlobe /> Кто здесь?",
      "about_community_list1": "Выпускники, которые добились многого",
      "about_community_list2": "Студенты, у которых всё впереди",
      "about_community_list3": "Преподаватели, вложившие душу",
      "about_community_list4": "Партнёры, которые верят в интеллект",
      "about_future_title": "<FaUsers /> Что дальше?",
      "about_future_text": "Мы не остановимся. Мы будем развивать мобильное приложение. Добавим AI-систему для подбора наставников. Сделаем глобальную карту выпускников. И создадим <strong>истинно цифровой кампус</strong>, где география не имеет значения.",
      "about_quote": "«Оставь след. Делись опытом. Будь примером.»",
      "about_quote_sub": "Это не просто сайт. Это движение. И ты — его часть.",
      "about_join_button": "Стать частью сообщества <FaArrowRight />",
      "news_title": "Новости ОшТУ",
      "news_subtitle": "Последние достижения и инновации нашего университета",
      "news_0_title": "ОшТУ запускает Инновационный Хаб ",
      "news_0_date": "12 апреля 2025",
      "news_0_desc": "Новый центр на базе ИТ-факультета готовит лидеров в сфере ИИ",
      "news_1_title": "Студенты создают дрона-эколога",
      "news_1_date": "5 марта 2025",
      "news_1_desc": "Инженеры разработали дрон для очистки рек",
      "news_read_more": "Подробнее",
      "students_title": "Поддержка студентов ОшТУ",
      "students_subtitle": "Программы и возможности для вашего профессионального роста и развития",
      "students_scholarship_title": "<FaGraduationCap /> Стипендиальная программа Ассоциации выпускников ОшТУ",
      "students_scholarship_desc1": "Это стратегический проект, который помогает молодым специалистам раскрыть свой потенциал, получить признание в научной среде и финансовую поддержку. Участвовать могут магистранты второго курса очной формы обучения.",
      "students_scholarship_desc2": "Чтобы принять участие, зарегистрируйтесь на сайте и подайте заявку через Личный кабинет.",
      "students_mentorship_title": "<FaHandshake /> Менторская программа для студентов ОшТУ",
      "students_mentorship_desc1": "Это уникальная возможность для студентов — получить поддержку опытного наставника в сфере своей специализации. Программа помогает развиваться и строить полезные связи.",
      "students_mentorship_desc2": "Зарегистрируйтесь на сайте и подайте заявку через Личный кабинет, чтобы присоединиться к программе.",
      "students_platform_title": "<FaLaptopCode /> Цифровая платформа для развития",
      "students_platform_desc": "На сайте студенты могут создавать личные кабинеты, отслеживать участие в программах, получать уведомления о стипендиях, мероприятиях и возможностях стажировок от партнёров ОшТУ.",
      "students_events_title": "<FaBullhorn /> Свежие новости и мероприятия",
      "students_events_desc": "Будьте в курсе последних событий: научные конференции, карьерные тренинги, мастер-классы и многое другое. Всё важное для студенческого сообщества — здесь.",
      "students_apply_button": "Подать заявку",
      "students_explore_button": "Изучить платформу",
      "students_view_events_button": "Смотреть мероприятия",
      "employment_stats_title": "Трудоустройство выпускников",
      "employment_stats_description": "Актуальная статистика и возможности для выпускников нашего университета",
      "view_stats_button": "Посмотреть статистику",
      "career_opportunities": "Вакансии",
      "success_stories": "Истории успеха",
      "employment_rate": "Уровень трудоустройства",
      "companies_partners": "Компаний-партнеров",
      "graduates_last_year": "Выпускников в прошлом году"
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'kg', // Default language
  fallbackLng: 'ru',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
